import React, { FC, useEffect, useState } from 'react';
import { ADDITIONAL_DELTA, MILLI } from '../../../constans/polls-constants';
import LoaderSpinner from '../../shared/custom-loader-spinner/loader-spinner';
import ProgressBar from '../../shared/progress-bar/progress-bar';

interface IProps {
  delay: number;
  handleFinishClosing: () => void;
  timestamp?: string;
}

const LIGHT_RED = '#ffcccc';
const INTERVAL = 250;
const FULL_NUMBER = 100;
const FOURTH_PART = 4;

const calculateCurrentDelay = (totalDelay: number, timestamp?: string,) => {
  const now = Date.now();
  const statusTimestamp = timestamp ? new Date(timestamp).getTime() : 0;
  const delta = (now - statusTimestamp) / MILLI;
  const result = delta * ADDITIONAL_DELTA / totalDelay;

  return result < 0 ? 0 : result;
};

const ClosingProgress: FC<IProps> = ({ delay, timestamp, handleFinishClosing }) => {
  const currentDelay = calculateCurrentDelay(delay, timestamp);
  const [progress, setProgress] = useState<number>(currentDelay);

  let intervalHandler: NodeJS.Timeout;

  useEffect(() => {
    intervalFiller();
    return () => {
      clearIntervalFiller();
    };
  }, []);


  const intervalFiller = (): void => {
    intervalHandler = setInterval(() => {
      setProgress((oldProgress) => {
        if (Math.floor(oldProgress) > FULL_NUMBER) {
          handleFinishClosing();
          clearIntervalFiller();
        }
        const percentPerTick = FULL_NUMBER / (delay * FOURTH_PART);
        return oldProgress + percentPerTick;
      });
    }, INTERVAL);
  };

  const clearIntervalFiller = (): void => {
    clearInterval(intervalHandler);
  };

  return (
    <div className='closing-progress-container'>
      <LoaderSpinner/>
      <span className='closing-text'>Closing...</span>
      <ProgressBar percents={progress} colorFill={LIGHT_RED} additionalClassName='closing' shouldHidePercents/>
    </div>
  );
};

export default ClosingProgress;
